import React from "react";
import HomePageHero from "./HomePageHero";
import LogoSliderV2 from "components/common/LogoSliderV2";
import PlatformSection from "./PlatformSection";
import ProductsSection from "./ProductsSection";
import TabberSection from "components/rui/page-components/TabberSection";
import CustomerStoriesSection from "./CustomerStoriesSection";
import ReviewBlade from "./ReviewBlade";
import CTABannerHome from "components/common/footer-banners/CTABannerHome";

const HomePage = () => {
  return (
    <>
      <HomePageHero />
      <LogoSliderV2 />
      <PlatformSection />
      <ProductsSection />
      <TabberSection
        preTitle={"OUR PLATFORM"}
        title={"Maximizing security and peace of mind"}
        blurb={
          " A platform that takes the worry out of physical security at scale"
        }
      />
      <ReviewBlade />
      <CustomerStoriesSection />
      <CTABannerHome />
    </>
  );
};

export default HomePage;
